var _linearGradient, _linearGradient2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.002579%",
    x2: "50.002579%",
    y1: "1.630391%",
    y2: "98.544844%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ff1b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#fa1a2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ed1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#d60e21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#b70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70014"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "49.9903%",
    x2: "49.9903%",
    y1: ".852968%",
    y2: "99.518975%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff4b4b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m85.9 200.1c-14.2-16.7-23.3-41.4-23.9-69.1v-6c.6-27.7 9.8-52.4 23.9-69.1 18.4-23.8 45.4-34.5 75.9-34.5 18.8 0 36.5 1.3 51.5 11.3-22.5-20.3-52.2-32.6-84.8-32.7h-.5c-70.7 0-128 57.3-128 128 0 68.6 54 124.7 121.9 127.9 2 .1 4.1.1 6.1.1 32.8 0 62.7-12.3 85.3-32.6-15 10-31.7 10.4-50.5 10.4-30.4.1-58.6-9.8-76.9-33.7z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m85.9 55.9c11.7-13.9 26.9-22.2 43.5-22.2 37.3 0 67.5 42.2 67.5 94.4s-30.2 94.4-67.5 94.4c-16.6 0-31.7-8.4-43.5-22.2 18.4 23.8 45.7 39 76.1 39 18.7 0 36.3-5.7 51.3-15.7 26.2-23.6 42.7-57.7 42.7-95.6s-16.5-72-42.7-95.4c-15-10-32.5-15.7-51.3-15.7-30.5 0-57.8 15.1-76.1 39z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpera);
export default __webpack_public_path__ + "static/media/icon_opera.2dc2628b9f328742cc4d0c5dfd1f2849.svg";
export { ForwardRef as ReactComponent };